<script>
import Status from "@/components/_Shared/Users/Status/Index";
import Attributes from "./Attributes";
import accountMixin from "@/mixins/accountMixin";

export default {
  mixins: [accountMixin],
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  components: {
    Status,
    Attributes
  }
};
</script>

<template>
  <v-card class="mb-20 px-4" flat>
    <v-layout column justify-center>
      <v-card-title primary-title>
        <v-icon color="black" class="mr-5">account_circle</v-icon>
        <h2 class="font-weight-thin mr-10">Conta</h2>
        <status :status="getStatus(account.status)" :statuses="getStatuses()" />
      </v-card-title>

      <v-divider></v-divider>

      <attributes :account="account" @refresh="$emit('refresh')" />
    </v-layout>
  </v-card>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/_Shared/Users/Account/Index.vue